<div class="impressum-container" animate.enter="entering">
    <div class="col1">
        <div class="info">
            <h2>leon zimmermann.</h2>
            <p class="text">
                Keltenstraße 8b
                <br>
                86697 Unterhausen
                <br>
                <br>
                Image by <a href="https://loreenadamski.com" class="links">loreen adamski</a>
                <br>
                <br>
                <br>
                This Website is made completly in 420 Mode
            </p>
        </div>
    </div>
    <div class="col2">
    </div>
</div>
<div class="haftung-container">
    <div class="col1">
        <h2>haftungsausschluss</h2>
        <p class="text"><br>
            Haftung für Inhalte<br>
            Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen
            Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
            übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf
            eine rechtswidrige Tätigkeit hinweisen. Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
            Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist
            jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
            entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
            <br><br>
            Haftung für Links<br>
            Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben.
            Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
            Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
            wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
            Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist
            jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von
            Rechtsverletzungen werden wir derartige Links umgehend entfernen.
            <br><br>
            Urheberrecht<br>
            Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
            Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
            Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
            Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit
            die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet.
            Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
            Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
            Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
        </p>
    </div>
    <div class="col2"></div>
</div>
<div class="datenschutz-container">
    <div class="col1">
        <h2>datenschutz.</h2>
        <p class="text"><br>
            ERFASSUNG ALLGEMEINER INFORMATIONEN<br>
            Wenn Sie auf unsere Webseite zugreifen, werden automatisch Informationen allgemeiner Natur erfasst. Diese
            Informationen (Server-Logfiles) beinhalten etwa die Art des Webbrowsers, das verwendete Betriebssystem, den
            Domainnamen Ihres Internet Service Providers und Ähnliches. Hierbei handelt es sich ausschließlich um
            Informationen, welche keine Rückschlüsse auf Ihre Person zulassen. Diese Informationen sind technisch
            notwendig, um von Ihnen angeforderte Inhalte von Webseiten korrekt auszuliefern und fallen bei Nutzung des
            Internets zwingend an. Anonyme Informationen dieser Art werden von uns statistisch ausgewertet, um unseren
            Internetauftritt und die dahinterstehende Technik zu optimieren.<br>
            <br>    
            COOKIES<br>
            Wie viele andere Webseiten verwenden wir auch so genannte „Cookies“. Cookies sind kleine Textdateien, die
            von einem Webseitenserver auf Ihre Festplatte übertragen werden. Hierdurch erhalten wir automatisch
            bestimmte Daten wie z. B. IP-Adresse, verwendeter Browser, Betriebssystem über Ihren Computer und Ihre
            Verbindung zum Internet.<br>
            <br>
            Cookies können nicht verwendet werden, um Programme zu starten oder Viren auf einen Computer zu übertragen.
            Anhand der in Cookies enthaltenen Informationen können wir Ihnen die Navigation erleichtern und die korrekte
            Anzeige unserer Webseiten ermöglichen.<br>
            <br>
            In keinem Fall werden die von uns erfassten Daten an Dritte weitergegeben oder ohne Ihre Einwilligung eine
            Verknüpfung mit personenbezogenen Daten hergestellt.<br>
            <br>
            Natürlich können Sie unsere Website grundsätzlich auch ohne Cookies betrachten. Internet-Browser sind
            regelmäßig so eingestellt, dass sie Cookies akzeptieren. Sie können die Verwendung von Cookies jederzeit
            über die Einstellungen Ihres Browsers deaktivieren. Bitte verwenden Sie die Hilfefunktionen Ihres
            Internetbrowsers, um zu erfahren, wie Sie diese Einstellungen ändern können. Bitte beachten Sie, dass
            einzelne Funktionen unserer Website möglicherweise nicht funktionieren, wenn Sie die Verwendung von Cookies
            deaktiviert haben.<br>
            <br>
            SSL-VERSCHLÜSSELUNG<br>
            <br>
            Um die Sicherheit Ihrer Daten bei der Übertragung zu schützen, verwenden wir dem aktuellen Stand der Technik
            entsprechende Verschlüsselungsverfahren (z. B. SSL) über HTTPS.<br>
            <br>
            KONTAKTFORMULAR<br>
            Treten Sie per E-Mail oder Kontaktformular mit uns in Kontakt, werden die von Ihnen gemachten Angaben zum
            Zwecke der Bearbeitung der Anfrage sowie für mögliche Anschlussfragen gespeichert.<br>
            <br>
            LÖSCHUNG BZW. SPERRUNG DER DATEN<br>
            <br>
            Wir halten uns an die Grundsätze der Datenvermeidung und Datensparsamkeit. Wir speichern Ihre
            personenbezogenen Daten daher nur so lange, wie dies zur Erreichung der hier genannten Zwecke erforderlich
            ist oder wie es die vom Gesetzgeber vorgesehenen vielfältigen Speicherfristen vorsehen. Nach Fortfall des
            jeweiligen Zweckes bzw. Ablauf dieser Fristen werden die entsprechenden Daten routinemäßig und entsprechend
            den gesetzlichen Vorschriften gesperrt oder gelöscht.<br>
            <br>
            VERWENDUNG VON GOOGLE ANALYTICS<br>
            <br>
            Diese Webseite benutzt Google Analytics, einen Webanalysedienst der Google Inc. (folgend: Google). Google
            Analytics verwendet sog. „Cookies“, also Textdateien, die auf Ihrem Computer gespeichert werden und die eine
            Analyse der Benutzung der Webseite durch Sie ermöglichen. Die durch das Cookie erzeugten Informationen über
            Ihre Benutzung dieser Webseite werden in der Regel an einen Server von Google in den USA übertragen und dort
            gespeichert. Aufgrund der Aktivierung der IP-Anonymisierung auf diesen Webseiten, wird Ihre IP-Adresse von
            Google jedoch innerhalb von Mitgliedstaaten der Europäischen Union oder in anderen Vertragsstaaten des
            Abkommens über den Europäischen Wirtschaftsraum zuvor gekürzt. Nur in Ausnahmefällen wird die volle
            IP-Adresse an einen Server von Google in den USA übertragen und dort gekürzt. Im Auftrag des Betreibers
            dieser Webseite wird Google diese Informationen benutzen, um Ihre Nutzung der Webseite auszuwerten, um
            Reports über die Webseitenaktivitäten zusammenzustellen und um weitere mit der Webseitennutzung und der
            Internetnutzung verbundene Dienstleistungen gegenüber dem Webseitenbetreiber zu erbringen. Die im Rahmen von
            Google Analytics von Ihrem Browser übermittelte IP-Adresse wird nicht mit anderen Daten von Google
            zusammengeführt.<br>
            <br>
            Sie können die Speicherung der Cookies durch eine entsprechende Einstellung Ihrer Browser-Software
            verhindern; wir weisen Sie jedoch darauf hin, dass Sie in diesem Fall gegebenenfalls nicht sämtliche
            Funktionen dieser Webseite vollumfänglich werden nutzen können. Sie können darüber hinaus die Erfassung der
            durch das Cookie erzeugten und auf Ihre Nutzung der Webseite bezogenen Daten (inkl. Ihrer IP-Adresse) an
            Google sowie die Verarbeitung dieser Daten durch Google verhindern, indem sie das unter dem folgenden Link
            verfügbare Browser-Plugin herunterladen und installieren: Browser-Add-on zur Deaktivierung von Google
            Analytics.<br>
            <br>
            Zusätzlich oder als Alternative zum Browser-Add-On können Sie das Tracking durch Google Analytics auf
            unseren Seiten unterbinden, indem Sie diesen Link anklicken. Dabei wird ein Opt-Out-Cookie auf Ihrem Gerät
            installiert. Damit wird die Erfassung durch Google Analytics für diese Website und für diesen Browser
            zukünftig verhindert, so lange der Cookie in Ihrem Browser installiert bleibt.<br>
            <br>
            IHRE RECHTE AUF AUSKUNFT, BERICHTIGUNG, SPERRE, LÖSCHUNG UND WIDERSPRUCH
            Sie haben das Recht, jederzeit Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten zu erhalten.
            Ebenso haben Sie das Recht auf Berichtigung, Sperrung oder, abgesehen von der vorgeschriebenen
            Datenspeicherung zur Geschäftsabwicklung, Löschung Ihrer personenbezogenen Daten. Bitte wenden Sie sich dazu
            an unseren Datenschutzbeauftragten. Die Kontaktdaten finden Sie ganz unten.<br>
            <br>
            Damit eine Sperre von Daten jederzeit berücksichtigt werden kann, müssen diese Daten zu Kontrollzwecken in
            einer Sperrdatei vorgehalten werden. Sie können auch die Löschung der Daten verlangen, soweit keine
            gesetzliche Archivierungsverpflichtung besteht. Soweit eine solche Verpflichtung besteht, sperren wir Ihre
            Daten auf Wunsch.<br>
            <br>
            Sie können Änderungen oder den Widerruf einer Einwilligung durch entsprechende Mitteilung an uns mit Wirkung
            für die Zukunft vornehmen.<br>
            <br>
            ÄNDERUNG UNSERER DATENSCHUTZBESTIMMUNGEN<br>
            Wir behalten uns vor, diese Datenschutzerklärung gelegentlich anzupassen, damit sie stets den aktuellen
            rechtlichen Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung
            umzusetzen, z. B. bei der Einführung neuer Services. Für Ihren erneuten Besuch gilt dann die neue
            Datenschutzerklärung.<br>
            <br>
            FRAGEN AN DEN DATENSCHUTZBEAUFTRAGTEN<br>
            Wenn Sie Fragen zum Datenschutz haben, schreiben Sie mir bitte eine E-Mail.<br>
    </div>
    <div class="col2"></div>
</div>